import { KENH_BAN_LABELS_VI, normalizeKenhBan } from '@/constants/kenhBan'

export const primaryCodeFromRow = (row: Record<string, unknown>): string => {
  const keys = [
    'maDonHang',
    'maHoaDon',
    'maPhieuTra',
    'maPhieuNhan',
    'maPhieuNhap',
    'maPhieu',
    'maKhachHang',
    'maDatHang',
    'maPhieuKiem',
    'maPhieuKiemKe',
    'maKenhBan',
    'maDonViTinh',
    'maThuongHieu',
    'maViTri',
    'maThuKhac',
    'maThuocTinh',
    'maPhieuChuyen',
    'maYeuCau',
    'ma',
    'soPhieu',
    'id',
  ]
  for (const k of keys) {
    const v = row[k]
    if (v != null && String(v).trim()) return String(v)
  }
  return '—'
}

const relLabel = (raw: unknown, ...fields: string[]): string | null => {
  if (!raw || typeof raw !== 'object') return null
  const o = raw as Record<string, unknown>
  for (const f of fields) {
    const v = o[f]
    if (v != null && String(v).trim()) return String(v).trim()
  }
  return null
}

export const secondaryLabelFromRow = (row: Record<string, unknown>): string => {
  // kenhBan giờ là scalar string (enum KENH_BAN), map sang label tiếng Việt
  if (typeof row.kenhBan === 'string' && row.kenhBan) {
    const code = normalizeKenhBan(row.kenhBan)
    return KENH_BAN_LABELS_VI[code] ?? row.kenhBan
  }

  const nested: Array<[unknown, string[]]> = [
    [row.khachHang, ['tenKhachHang', 'hoTen']],
    [row.nhaCungCap, ['tenNhaCungCap', 'ten']],
  ]
  for (const [rel, fields] of nested) {
    const label = relLabel(rel, ...fields)
    if (label) return label.slice(0, 160)
  }

  const keys = [
    'tenKhachHang',
    'tenNhaCungCap',
    'tenDonViTinh',
    'tenThuongHieu',
    'tenViTri',
    'tenThuKhac',
    'tenPhanLoai',
    'ten',
  ]
  for (const k of keys) {
    const v = row[k]
    if (v != null && String(v).trim()) return String(v).slice(0, 160)
  }
  return '—'
}

export const noteFromRow = (row: Record<string, unknown>): string => {
  const ghiChu = row.ghiChu
  if (ghiChu != null && String(ghiChu).trim()) return String(ghiChu).trim().slice(0, 240)
  const moTa = row.moTa
  if (moTa != null && String(moTa).trim()) return String(moTa).trim().slice(0, 240)
  return '—'
}
